import { render, staticRenderFns } from "./sjzx.vue?vue&type=template&id=0946ba1c&"
import script from "./sjzx.vue?vue&type=script&lang=ts&"
export * from "./sjzx.vue?vue&type=script&lang=ts&"
import style0 from "./sjzx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports